import { DOC_NAMES } from '../constants/strings';
import {BASE_URLS} from "../config/urls";

export class DocumentService {
    private readonly base = `${BASE_URLS.api}/admin/documents/by-name`;

    async getOpenUrl(name: string): Promise<string | undefined> {
        try {
            const res = await fetch(`${this.base}/${encodeURIComponent(name)}`, {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });
            if (!res.ok) return undefined;
            const dto = await res.json();
            return dto?.openUrl as string | undefined;
        } catch {
            return undefined;
        }
    }

    async getAll() {
        const [regulations, oferta, privacy] = await Promise.all([
            this.getOpenUrl(DOC_NAMES.REGULATIONS),
            this.getOpenUrl(DOC_NAMES.OFERTA),
            this.getOpenUrl(DOC_NAMES.PRIVACY),
        ]);
        return { regulations, oferta, privacy };
    }
}
